import { AsyncPipe, NgIf } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { HeroNameTagComponent } from '@components';
import { DesktopDirective, MobileDirective, TabletLandscapeDirective, TabletPortraitDirective } from '@directives';
import { AuthService, ContentService } from '@services';
import { OrchestratorSpotlight } from '@shared/services/content/interfaces/cms-orchestrator-spotlight.interface';
import { Observable } from 'rxjs';
import { GknRoutePath } from 'src/app/app-routing.enum';

@Component({
    selector: 'app-home-hero',
    imports: [
        AsyncPipe,
        NgIf,
        DesktopDirective,
        HeroNameTagComponent,
        TabletLandscapeDirective,
        TabletPortraitDirective,
        MobileDirective,
        RouterLink,
        MatTooltipModule,
    ],
    templateUrl: './home-hero.component.html',
    styleUrls: ['./home-hero.component.scss'],
})
export class HomeHeroComponent implements OnInit {
    private authService = inject(AuthService);
    private contentService = inject(ContentService);

    signUpRoute = GknRoutePath.SIGNUP;
    spotlight$: Observable<OrchestratorSpotlight[]>;

    ngOnInit(): void {
        this.spotlight$ = this.contentService.orchestratorSpotlights$('home');
    }

    signInWithRedirect(e: Event): void {
        e?.stopPropagation();
        this.authService.signInWithRedirect();
    }
}
